'use client';

import { useCallback, useEffect, useRef, type FC } from 'react';

import { MXP365_V2_EVENTS, type Mxp365V2OpenEvent } from './events-v2';
import { Mxp365DialogV2, type Mxp365DialogV2Ref } from './Mxp365DialogV2';

import type { MxpDialogTitleCollection } from '../mxp365.types';

type Props = {
  titles?: MxpDialogTitleCollection;
};

export const Mxp365DialogV2Provider: FC<Props> = ({ titles }) => {
  const dialogRef = useRef<Mxp365DialogV2Ref>(null);

  const handleOpenEvent = useCallback((event: Event) => {
    const customEvent = event as Mxp365V2OpenEvent;
    const { module, parameter, title, token, queryParams, telemetry } =
      customEvent.detail;

    dialogRef.current?.initiateNavigation({
      module,
      parameter,
      title,
      token,
      queryParams,
      telemetry,
    });
  }, []);

  const handleCloseEvent = useCallback(() => {
    /* dialog manages its own open state; placeholder for external close triggers */
  }, []);

  useEffect(() => {
    window.addEventListener(MXP365_V2_EVENTS.OPEN, handleOpenEvent);
    window.addEventListener(MXP365_V2_EVENTS.CLOSE, handleCloseEvent);

    return () => {
      window.removeEventListener(MXP365_V2_EVENTS.OPEN, handleOpenEvent);
      window.removeEventListener(MXP365_V2_EVENTS.CLOSE, handleCloseEvent);
    };
  }, [handleOpenEvent, handleCloseEvent]);

  return <Mxp365DialogV2 ref={dialogRef} titles={titles} />;
};
